classifier.filter('showClassifiers', (classifierService) => {
    "use strict";
    return (additionalClassifications, type) => {
        if (['kpk_2019', 'kpk_2020', 'kpk_2021', 'kpk_2022', 'kpk_2023',
            'kpk_2024', 'kpk_2025', 'kpk_2026', 'tkpkmb', 'cpv', 'kpk', 'katottg'].includes(type)) {
            if (additionalClassifications && additionalClassifications.id && additionalClassifications.id.length > 0) {
                return additionalClassifications.id + '-' + additionalClassifications.description;
            } else {
                return ''
            }
        } else {

            let dkSchems = classifierService.getGroupSchemeByType(type);
            let classifications = (additionalClassifications || []).filter((cl) => {
                return dkSchems.has(cl.scheme);
            });
            let names = classifications.map((cl) => {
                return cl.id + '-' + cl.description;
            });
            return names.join('; ');
        }
    }
});
